module.exports = __webpack_public_path__ + "img/text-separator1.425ca880.png";